module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic__mobile--AT-970c6196fcb39e6115d3e153f3333b56.jpg";